import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  width: "16",
  height: "16",
  viewBox: "0 0 16 16",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("g", { id: "bold" }, [
      _createElementVNode("path", {
        id: "vector",
        d: "M8.99996 8.00065H3.66663M8.99996 8.00065C10.4727 8.00065 11.6666 6.73212 11.6666 5.16732C11.6666 3.60251 10.4727 2.33398 8.99996 2.33398H3.66663V8.00065M8.99996 8.00065H9.66663C11.1394 8.00065 12.3333 9.26918 12.3333 10.834C12.3333 12.3988 11.1394 13.6673 9.66663 13.6673H3.66663V8.00065",
        stroke: "currentColor",
        "stroke-linecap": "square"
      })
    ], -1)
  ])))
}
export default { render: render }